var map = {
	"./all-in-one": 58,
	"./all-in-one.png": 58,
	"./citrusovy-deodorant": 59,
	"./citrusovy-deodorant.jpg": 59,
	"./sort": 60,
	"./sort.png": 60,
	"./weleda_logo": 61,
	"./weleda_logo.png": 61,
	"./weleda_logo_2024": 62,
	"./weleda_logo_2024.png": 62,
	"./weleda_logo_admin": 63,
	"./weleda_logo_admin.png": 63,
	"./weleda_logo_grey_reduced_nav": 64,
	"./weleda_logo_grey_reduced_nav.png": 64
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 377;